import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { map, take, filter } from 'ramda';

import { createSummaryTile } from '../containers/SummaryLoaderContainer';

import { path } from 'routes/Documents/routes/Comorbidity';
import TileRow from './TileRow';
import { formatDate } from 'lib/dateDisplay';

import icon from '../assets/comorbidity.svg';

const predicate = d => d.diagnosisDate && d.diagnosis;

const View = ({ data, localeMessage }) => (
  <Grid fluid>
    {map(d => (
      <TileRow key={d.documentId} title={formatDate(d.diagnosisDate)}>
        <p className="bold">{localeMessage(d.diagnosis)}</p>
      </TileRow>
    ))(take(3, filter(predicate, data)))}
  </Grid>
);

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default createSummaryTile(View, { module: 'comorbidity', localeId: 'comorbidity.title', routeTo: path, icon });
